<template>
<div class="upload_wrap">
    <div class="upload_content">
        <div class="upload_file" @click="uploadFiles" v-show="!fileList">
            <i class="el-icon-plus"></i>
        </div>
        <uploaderImage v-show="false" ref="uploadFile" @input="handleChange" uploadSize="20mb" :accept="accept" :isAddSucaiFlag="false" @uploadSucess="uploadSucess"/>
        <div class="fileList_li" v-show="value">
            <img
                class="fileList_li_img"
                :src="fileList" alt=""
            >
            <div class="fileList_li_mask">
                <i class="el-icon-zoom-in icon" @click="handlePictureCardPreview"></i>
                <i class="el-icon-delete icon"  @click="handleRemove"></i>
            </div>
        </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" custom-class="preivew_img_dialog" :modal="false">
        <img width="100%" :src="value" alt="">
    </el-dialog>
</div>
</template>
<script>
import {mapActions} from 'vuex'
import { uploadQiNiuyun } from './upload.js'
import uploaderImage from '../newUpload/upload.vue'
export default {
    mixins: [uploadQiNiuyun],
    props: {
        accept: {
            type: Array,
            default: () => ['.jpg', '.png', '.jpeg', '.tif','.jfif']
        },
        limit: {
            type:Number,
            default: 6
        },
        value: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            dialogVisible: false,
            fileList: '',
            sizeFlag: true,
            isUpload: false
        }
    },
    components: {
        uploaderImage
    },
    methods: {
        ...mapActions('uploads',['getUploaderToken']),
        uploadFiles() {
            this.$refs.uploadFile.uploadFile()
        },
        uploadSucess(list) {
            this.$emit('input', list[0].url)
        },
        // async handleChange(e) {
        //     let file = e.target.files[0]
        //     let suffix = file.name.slice(file.name.lastIndexOf('.'), file.name.length)
        //     if(!this.accept.includes(suffix.toLocaleLowerCase())) {
        //         this.$refs.uploadFile.value = '';
        //         setTimeout(async () => {
        //             let htmls = document.querySelector('.fileTypeMessage')
        //             if(htmls) {
        //                htmls.style.display = 'none'
        //             }
        //             await this.$message({
        //                 type: 'error',
        //                 customClass: 'fileTypeMessage',
        //                 message: '上传文件格式不正确，请上传后缀名为'+ this.accept.join(',') + '文件',
        //                 duration: 2000
        //             })
        //         }, 50)
        //         return
        //     }
        //     let isLt5M = file.size > 20*1024*1024
        //     if (isLt5M) {
        //         this.$refs.uploadFile.value = '';
        //         this.sizeFlag = false
        //         setTimeout(async () => {
        //             let htmls = document.querySelector('.fileSizeMessage')
        //             if(htmls) {
        //               htmls.style.display = 'none'
        //             }
        //             await this.$message({
        //                 type: 'error',
        //                 message: '请上传20M内的图片',
        //                 customClass: 'fileSizeMessage',
        //                 duration: 2000
        //             })
        //         }, 100)
        //         return
        //     }
        //     let res = await this.getUploaderToken()
		// 	this.uploadSdk(file, res.token, 'img', res.timestamp)
        // },
        handlePictureCardPreview(file) {
            this.dialogVisible = true;
        },
        // onError(e) {
        // },
        handleRemove(index) {
            this.$emit('input', '')
        },
        // onExceed(files, fileList) {
        //     console.log(files, fileList)
        // }
    },
    watch: {
        value: {
            immediate: true,
            handler(news) {
                this.fileList = news
            }
        } 
    }
}
</script>
<style lang="less">
    .preivew_img_dialog {
        margin-top: 24px!important;
        min-width: 50%;
        max-height: 90%;
        display: flex;
        flex-direction: column;
        .el-dialog__body {
            overflow-y: auto;
            flex: 1;
            height: 0;
        }
    }
</style>
<style lang="less" scoped>
    .upload_content {
        display: flex;
    }
    .upload_file {
        width: 148px;
        height: 148px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        box-sizing: border-box;
        margin-bottom: 8px;
    }
    .fileList_li {
        overflow: hidden;
        background-color: #fff;
        border: 1px solid #c0ccda;
        border-radius: 6px;
        box-sizing: border-box;
        width: 148px;
        height: 148px;
        margin: 0 8px 8px 0;
        display: inline-block;
        position: relative;
        .fileList_li_mask {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background: rgba(0, 0, 0, 0.6);
            display: flex;
            justify-content: center;
            align-items: center;
            transition: all 0.2s linear;
            transform: translateY(-100%);
            .icon {
                font-size: 16px;
                color: #fff;
                cursor: pointer;
                &:nth-child(2) {
                    margin-left: 6px;
                }
            }
        }
        &:hover .fileList_li_mask {
            transform: translateY(0);
        }
        .fileList_li_img {
            width: 100%;
        }
    }
</style>